// extracted by mini-css-extract-plugin
module.exports = {"datagrid":"Datagrid_datagrid__hR3G0"};